import { GraphqlStoreBase, } from "./GraphqlStoreBase";
import { flow } from "mobx";
export class GraphqlMutableStoreBase extends GraphqlStoreBase {
    constructor(name, authStore, apolloClient, mutationDocument, mutationVariablesBuilder, queryDocument, queryResultDataExtractor, queryResultDataItemPatcher) {
        super(name, authStore, apolloClient, queryDocument, queryResultDataExtractor, queryResultDataItemPatcher);
        this.updateItem = flow(function* (item) {
            this.setState("updating");
            try {
                const updatedItemIndex = this.data.findIndex(existingItem => existingItem.id === item.id);
                if (updatedItemIndex === -1) {
                    throw new Error("Item not found");
                }
                // Remove GraphQL-injected fields that won't be accepted in a GraphQL mutation
                if (item.__typename) {
                    delete item.__typename;
                }
                const mutationVariables = this.mutationVariablesBuilder(item);
                // TypeScript clowning around for MobX/flow requiring yield vs. await
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const yieldedMutationResult = yield this.apolloClient.mutate({
                    mutation: this.mutationDocument,
                    variables: mutationVariables,
                });
                const mutationResult = yieldedMutationResult;
                if (mutationResult.errors) {
                    throw new Error(JSON.stringify(mutationResult.errors)); // stringify errors
                }
                this.data[updatedItemIndex] = item;
                this.setState("ready");
            }
            catch (error) {
                this.setError(JSON.stringify(error)); // stringify exception
            }
        });
        this.mutationDocument = mutationDocument;
        this.mutationVariablesBuilder = mutationVariablesBuilder;
    }
}
//# sourceMappingURL=GraphqlMutableStoreBase.js.map